import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import '../../../styles/savers/select-search.css';
import { calculateLinearFeet } from '@/utils/savers/utils';
import WarningModal from '@/views/components/Modals/WarningModal';
import { Button, Card, Col, Form, Row, Tooltip } from 'antd';
import { Progress as CustomProgress } from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { setTrailerRequestId } from '../../../redux/Savers/SaversActions';
import {
  getAllFreightCommodityIdEffect,
  getBranchesbyCustomerEffect,
  getTrailerDetailsEffect,
  getTrailerRequestByIDEffect,
  getTrailerRequestStatusEffect,
  getTrailersListEffect,
  getUnitSizesEffect,
  getUserRelationEffect,
  getUserTypeEffect,
  saveTrailerRequest,
} from '../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import { getFormattedTimeString } from '../../../utilz';
import FormDatePicker from '../../components/Inputs/FormDatePicker';
import FormInput from '../../components/Inputs/FormInput';
import FormSelectBox from '../../components/Inputs/FormSelectBox';
import FormTextArea from '../../components/Inputs/FormTextArea';
import FormTimePicker from '../../components/Inputs/FormTimePicker';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import Paper from '../../components/Paper/Paper';
import { DEFAULT_PAGE_NUMBER } from './trailer-request.constants';

const deliveryTimeOptions = [
  {
    value: '8 AM to 12 P.M',
    label: '8 AM to 12 P.M',
  },
  {
    value: '12 PM to 4 P.M',
    label: '12 PM to 4 P.M',
  },
];

const getTrailerLabel = (size, options) => {
  const match = options?.find((val) => val.value === size);
  return match?.label || size;
};

const DEFAULT_PAGE_SIZE = 500;

export default function TrailerReview() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const requestID = useSelector((state) => state.savers.reqID.data);
  const userRole = useSelector((state) => state.savers.loggedInUser.data);

  const [formUpdateTrailerRequest] = Form.useForm();

  const [pTimeToCheck, setPTimeToCheck] = useState('');

  const [requestType, setRequestType] = useState('');
  const [nameLabel, setNameLabel] = useState('Team Member Name');
  const [locationLabel, setLocationLabel] = useState('Team Member Location ID');
  const [addressLabel, setAddressLabel] = useState('Team Member Address');
  const [phoneLabel, setPhoneLabel] = useState('Team Member Phone #');
  const [trlHidden, setTrlHidden] = useState(false);

  const [pickupDateLabel, setPickupDateLabel] = useState('Pickup Date');
  const [pickupTimeLabel, setPickupTimeLabel] = useState('Pickup Time');

  const [selectedValue, setSelectedValue] = useState('');

  const [selectedTrailerPickValue, setSelectedTrailerPickValue] = useState('');
  const [selectedTrailerDoorValue, setSelectedTrailerDoorValue] = useState('');
  const [selectedLoadValue, setSelectedLoadValue] = useState('');

  const [partnerLocationOptions, setPartnerLocationOptions] = useState([]);
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [trailerSizeOptions, setTrailerSizeOptions] = useState([]);
  const [commodityOptions, setCommodityOptions] = useState([]);
  const [trailerRequestStatusOptions, setTrailerRequestStatusOptions] = useState([]);
  const [trafficCoordinatorOptions, setTrafficCoordinatorOptions] = useState([]);

  const [hidden, setHidden] = useState(true);
  const [checked, setChecked] = useState(false);

  const [trailerReqID, setTrailerReqID] = useState(0);
  const [productName, setProductName] = useState('');
  const [trailerID, setTrailerID] = useState(0);
  const [trailerName, setTrailerName] = useState('');
  const [locationID, setLocationID] = useState(0);
  const [pickupTrailerSize, setPickupTrailerSize] = useState('');
  const [trailerConditionStatusID, setTrailerConditionStatusID] = useState('');
  const [trailerRequestDate, setTrailerRequestDate] = useState('');
  const [trafficCoordinatorID, setTrafficCoordinatorID] = useState(null);
  const [trailerRequestStatusID, setTrailerRequestStatusID] = useState('');
  const [trailerRequestStatusDesc, setTrailerRequestStatusDesc] = useState('');
  const [isLoadedPickUp, setIsLoadedPickUp] = useState(false);
  const [isEmptyPickUp, setIsEmptyPickUp] = useState(false);
  const [productType, setProductType] = useState('');
  const [sealNumber, setSealNumber] = useState(0);
  const [productTypeDesc, setProductTypeDesc] = useState('');
  const [deliveryproductType, setdeliveryProductType] = useState('');
  const [deliveryproductTypeDesc, setdeliveryProductTypeDesc] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [deliveryTime, setDeliveryTime] = useState('');
  const [isEmptyDelivered, setIsEmptyDelivered] = useState(false);
  const [isLoadedDelivered, setIsLoadedDelivered] = useState(false);
  const [isMultiStop, setIsMultiStop] = useState(false);
  const [trailerDoorType, setTrailerDoorType] = useState('');
  const [isLiveLoad, setIsLiveLoad] = useState(false);
  const [estimatedWeight, setEstimatedWeight] = useState(0);
  const [estimatedDimension, setEstimatedDimension] = useState(0);
  const [specialInstruction, setSpecialInstruction] = useState('');
  const [deliveryestimatedWeight, setdeliveryEstimatedWeight] = useState(0);
  const [deliveryestimatedDimension, setdeliveryEstimatedDimension] = useState(0);

  const [newSuccessAlert, setNewSuccessAlert] = useState(false);
  const successMessage = 'Do you want to save the recent changes made to the request?';

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [fullName, setFullName] = useState('');

  const [branchKey, setBranchKey] = useState(0);
  const [branchAddr1, setBranchAddr1] = useState('');
  const [branchBusPhone, setBranchBusPhone] = useState('');
  const [rscm, setRSCM] = useState('');
  const [scs, setSCS] = useState('');
  const [requester, setRequester] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [requesterType, setRequesterType] = useState('');

  const [branchAddr2, setBranchAddr2] = useState('');
  const [branchCity, setBranchCity] = useState('');
  const [branchState, setBranchState] = useState('');
  const [branchPostal, setBranchPostal] = useState('');
  const [branchCustRef, setBranchCustRef] = useState('');

  const [trailerRequestData, setTrailerRequestData] = useState([]);
  const [stop1, setStop1] = useState(0);
  const [stop2, setStop2] = useState(0);
  const [stop3, setStop3] = useState(0);

  const [trailerRequestLocation, setTrailerRequestLocation] = useState('');
  const [stopDesc2, setStopDesc2] = useState('');
  const [disableFlag, setDisableflag] = useState(false);

  const [requestCondition, setRequestCondition] = useState('');

  const [liveLoadHoursOptions] = useState([
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ]);

  const [liveLoadHours, setLiveLoadHours] = useState(0);
  const [warningModal, setWarningModal] = useState(false);
  const [warning, setWarning] = useState('');
  const [requestUserType, setRequestUserType] = useState('');

  const onConfirmFunc = () => {
    setNewSuccessAlert(false);
  };

  const onProceed = () => {
    if (
      ValidateLoaded() &&
      ValidateTrailer() &&
      ValidatePickUpdate() &&
      ValidateCommodity() &&
      ValidateDelCommodity() &&
      ValidateStop() &&
      ValidateTrafficCoordinator() &&
      ValidateDeliveryTimeRange()
    ) {
      setNewSuccessAlert(true);
    }
  };

  useEffect(() => {
    if (
      requestCondition &&
      (requestCondition === 'ACK' ||
        requestCondition === 'ACK ' ||
        requestCondition === 'CNF' ||
        requestCondition === 'CNF ')
    ) {
      setDisableflag(true);
    }
  }, [requestCondition]);

  useEffect(() => {
    getTrailerList();
    getTrailerSizes();
    getTrailerCommodities();
    getTrailerRequestStatus();
    getUserRelations();
    getTrafficCoordinator();
  }, []);

  useEffect(() => {
    if (companyId !== undefined && companyId !== 0 && companyId !== '0' && companyId !== '') {
      getPartnerLocations(companyId);
      getTrailerList();
      getTrailerSizes();
      getTrailerCommodities();
      getTrailerRequestStatus();
      getUserRelations();
      getTrafficCoordinator();
    }
  }, [companyId]);

  useEffect(() => {
    if (requestID.length !== 0 && requestID !== undefined && requestID !== 0 && requestID !== '0' && requestID !== '') {
      getPartnerLocations(companyId);
      getTrailerList();
      getTrailerSizes();
      getTrailerCommodities();
      getTrailerRequestStatus();
      getUserRelations();
      getTrafficCoordinator();
      getTrailerRequestData(requestID);
    }
  }, [requestID]);

  useEffect(() => {
    if (trailerRequestData && trailerRequestData.length > 0) {
      const request = trailerRequestData?.[0]?.trailerRequestData?.[0] ?? {};
      dispatch(setAppLoader(true));
      setRequestType(request.requestType);
      setTrailerReqID(request.trailerRequestID);
      setLocationID(request.locationID);
      setTrailerRequestLocation(request.branchDesc);
      setTrailerID(request.trailerID);
      setTrailerName(request.trailerNumber);
      setTrailerConditionStatusID(request.trailerConditionStatusID);
      setTrailerRequestDate(request.trailerRequestDate);
      setPTimeToCheck(moment(request.deliveryDate).format('HH:mm'));
      setTrafficCoordinatorID(request.trafficCoordinatorID);
      setTrailerRequestStatusID(request.trailerRequestStautsID);
      setTrailerRequestStatusDesc(request.trailerRequestStatusDesc);
      setIsLoadedPickUp(request.isLoadedPickUp);
      if (request.isLoadedPickUp === true) {
        setChecked(true);
        setSelectedTrailerPickValue('Loaded');
        setPickupDateLabel('Date Trailer Loaded');
        setPickupTimeLabel('Time Trailer Loaded');
      } else {
        if (request.isEmptyPickUp === true) {
          setChecked(false);
          setSelectedTrailerPickValue('Empty');
          setPickupDateLabel('Date Trailer Emptied');
          setPickupTimeLabel('Time Trailer Emptied');
        } else {
          setChecked(false);
          setSelectedTrailerPickValue('None');
          setPickupDateLabel('Pickup Date');
          setPickupTimeLabel('Pickup Time');
        }
      }

      setIsEmptyPickUp(request.isEmptyPickUp);
      setProductType(request.productType);
      setProductTypeDesc(request.productTypeDesc);
      setEstimatedWeight(request.estimatedWeight);
      setEstimatedDimension(request.estimatedDimension);
      setdeliveryProductType(request.deliveryProductType);
      setdeliveryProductTypeDesc(request.deliveryProductTypeDesc);
      setdeliveryEstimatedWeight(request.deliveryEstimatedWeight);
      setdeliveryEstimatedDimension(request.deliveryEstimatedDimension);
      setDeliveryDate(request.deliveryDate);
      setDeliveryTime(request.deliveryTimeFrame);
      setIsEmptyDelivered(request.isEmptyDelivered);
      setIsLoadedDelivered(request.isLoadedDelivered);
      if (request.isLoadedDelivered === true) {
        setSelectedValue('Loaded');
      } else {
        if (request.isEmptyDelivered === true) {
          setSelectedValue('Empty');
        } else {
          setSelectedValue('None');
        }
      }
      setIsMultiStop(request.isMultiStop);
      setTrailerDoorType(request.trailerDoorType);
      if (request.trailerDoorType === 'SWNGDR') {
        setSelectedTrailerDoorValue('Swingdoor');
      } else if (request.trailerDoorType === 'RLLUPDR') {
        setSelectedTrailerDoorValue('RollUpdoor');
      } else if (request.trailerDoorType === 'SLDNGDR') {
        setSelectedTrailerDoorValue('Slidingdoor');
      } else if (request.trailerDoorType === 'FLDNGDR') {
        setSelectedTrailerDoorValue('Foldingdoor');
      } else if (request.trailerDoorType === 'HNGDR') {
        setSelectedTrailerDoorValue('Hingeddoor');
      }
      setIsLiveLoad(request.isLiveLoad);
      if (request.isLiveLoad === true) {
        setSelectedLoadValue('Load');
      } else {
        setSelectedLoadValue('UnLoad');
      }
      if (request?.liveLoadHours) {
        setLiveLoadHours(request?.liveLoadHours);
      }
      setSpecialInstruction(request.specialInstruction);
      setFullName(request.fullName);
      setBranchKey(request.branchCustRef);
      setRSCM(request.rscm);
      setSCS(request.scs);
      setBranchAddr1(request.branchAddr1);
      setBranchAddr2('');
      setBranchCity(request.branchCity);
      setBranchState(request.branchStateName);
      setBranchPostal(request.branchZip);
      setBranchCustRef(request.branchCustRef);
      setBranchBusPhone(request.branchBusPhone);
      setPhoneNumber(request.requesterPhone);
      setProductName(request.commodity);
      setRequester(request.requesterName);
      if (request.supplierNumber) {
        if (request.supplierNumber !== null && request.supplierNumber !== '') {
          setRequesterType('Supplier');
        } else {
          setRequesterType('');
        }
      }
      if (trailerRequestData[0].trailerRequestStopDetailsData.length > 0) {
        if (trailerRequestData[0].trailerRequestStopDetailsData.length === 1) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 2) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
          setStop2(trailerRequestData[0].trailerRequestStopDetailsData[1].locationID);
          setStopDesc2(trailerRequestData[0].trailerRequestStopDetailsData[1].branchDesc);
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 3) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
          setStop2(trailerRequestData[0].trailerRequestStopDetailsData[1].locationID);
          setStopDesc2(trailerRequestData[0].trailerRequestStopDetailsData[1].branchDesc);
          setStop3(trailerRequestData[0].trailerRequestStopDetailsData[2].locationID);
        }
      }

      if (request?.liveLoadHours) {
        formUpdateTrailerRequest.setFieldsValue({
          LiveLoadHours: request?.liveLoadHours,
        });
      }
      const trailerData = trailerRequestData[0]?.trailerRequestData[0] || {};
      formUpdateTrailerRequest.setFieldsValue({
        txtfullName: trailerData.fullName,
        txtSCS: trailerData.scs,
        txtRSCM: trailerData.rscm,
        txtAddr1: trailerData.branchAddr1,
        txtPhone: trailerData.branchBusPhone,
        txtDelLocation: trailerData.locationID,
        txtSpclInstruct: trailerData.specialInstruction,
        PartnerLocation: trailerData.branchDesc,
        ConditionStatus: trailerData.trailerConditionStatusID,
        selRequestStatus: trailerData.trailerRequestStatusDesc,
        selCommodity: trailerData.productType && Number.parseInt(trailerData.productType, 10),
        sealNumber: trailerData.sealNumber,
        selCommodity1: trailerData.deliveryProductType && Number.parseInt(trailerData.deliveryProductType, 10),
        selectDeliveryTime: trailerData.deliveryTimeFrame,
        pickupLocation: trailerData?.branchDesc,
        deliveryLocation: trailerData?.branchDesc,
        deliveryDate: trailerData.deliveryDate ? moment(trailerData.deliveryDate) : null,
      });
      setSealNumber(trailerData.sealNumber);
      if (trailerData?.isLoadedPickUp || trailerData?.isEmptyPickUp) {
        formUpdateTrailerRequest.setFieldsValue({
          trailerDate: trailerData.trailerRequestDate ? moment(trailerData.trailerRequestDate) : null,
          selectPickupTime: trailerData.trailerRequestDate ? moment(trailerData.trailerRequestDate) : null,
        });
      }
      if (trailerData.trailerID) {
        formUpdateTrailerRequest.setFieldsValue({
          selTrailerName: trailerData.trailerID,
        });
      }
      if (trailerData.pickupTrailerSize) {
        formUpdateTrailerRequest.setFieldsValue({
          trailerSize: Number(trailerData.unitSize),
        });
        setPickupTrailerSize(request.pickupTrailerSize);
      }
      if (trailerData.trafficCoordinatorID) {
        formUpdateTrailerRequest.setFieldsValue({
          TrafficCoord: trailerData.trafficCoordinatorID,
        });
      }
      if (request.supplierNumber) {
        if (request.supplierNumber !== null && request.supplierNumber !== '') {
          formUpdateTrailerRequest.setFieldsValue({
            txtRequester: request?.requesterName,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtState: request?.branchStateName,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtCity: request?.branchCity,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtPostal: request?.branchZip,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtPhone: request?.requesterPhone,
          });
        }
      }

      if (trailerRequestData[0].trailerRequestStopDetailsData.length > 0) {
        if (trailerRequestData[0].trailerRequestStopDetailsData.length === 1) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 2) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop2: trailerRequestData[0].trailerRequestStopDetailsData[1]?.branchDesc,
          });
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 3) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop2: trailerRequestData[0].trailerRequestStopDetailsData[1]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop3: trailerRequestData[0].trailerRequestStopDetailsData[2]?.branchDesc,
          });
        }
      }
      dispatch(setAppLoader(false));
    }
  }, [trailerRequestData]);

  const getTrafficCoordinator = async () => {
    try {
      const { data } = await getUserTypeEffect('CT');

      const options = data.map((row) => ({
        label: row.fullName,
        value: row.userId,
      }));
      setTrafficCoordinatorOptions(options);
    } catch (error) {
      console.error(error);
      setTrafficCoordinatorOptions([]);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const getPartnerLocations = async (companyId) => {
    dispatch(setAppLoader(true));
    if (companyId !== undefined && companyId !== 0 && companyId !== '0' && companyId !== '') {
      try {
        // TODO: useGetShipmentVendorBranch hook
        const { data } = await getBranchesbyCustomerEffect(companyId);

        const options = data.map((row) => ({
          label: row.branchDesc,
          value: row.branchKey,
        }));
        setPartnerLocationOptions(options);
      } catch (error) {
        console.error(error);
        setPartnerLocationOptions([]);
        console.error(branchKey);
      }
    }
  };

  const getTrailerRequestData = async (requestID) => {
    dispatch(setAppLoader(true));
    if (requestID !== undefined && requestID !== 0 && requestID !== '0' && requestID !== '') {
      try {
        const { data } = await getTrailerRequestByIDEffect(requestID);

        setTrailerRequestData(data);
        if (data.length > 0) {
          setRequestUserType(data[0].trailerRequestData[0].userType);
          setTrailerName(data[0].trailerRequestData[0].trailerNumber);

          setRequestCondition(data[0].trailerRequestData[0].trailerRequestStautsID);
        }
      } catch (error) {
        console.error(error);
        setTrailerRequestData([]);
      } finally {
        dispatch(setAppLoader(false));
      }
    }
  };

  const SaveTrailerRequest = async () => {
    dispatch(setAppLoader(true));
    const requestData = [];
    try {
      requestData.push({
        trailerRequestID: trailerReqID,
        locationID: locationID,
        trailerID: trailerID,
        pickupTrailerSize: pickupTrailerSize.toString(),
        trailerConditionStatusID: trailerConditionStatusID,
        trailerRequestDate: trailerRequestDate,
        trafficCoordinatorID: trafficCoordinatorID,
        trailerRequestStautsID: trailerRequestStatusID,
        isLoadedPickUp: isLoadedPickUp,
        isEmptyPickUp: isEmptyPickUp,
        productType: productType.toString(),
        deliveryDate: deliveryDate,
        deliveryTimeFrame: deliveryTime,
        isEmptyDelivered: isEmptyDelivered,
        deliveryProductType: deliveryproductType.toString(),
        isLoadedDelivered: isLoadedDelivered,
        isMultiStop: isMultiStop,
        trailerDoorType: trailerDoorType,
        isLiveLoad: isLiveLoad,
        specialInstructionTrailerSize: '',
        specialInstruction: specialInstruction,
        stopOne: stop1,
        stopTwo: stop2,
        stopThree: stop3,
        requestType: requestType,
        liveLoadHours: liveLoadHours,
        estimatedWeight: estimatedWeight,
        estimatedDimension: estimatedDimension,
        deliveryEstimatedWeight: deliveryestimatedWeight,
        deliveryEstimatedDimension: deliveryestimatedDimension,
        sealNumber: sealNumber,
        requesterName: requester,
        requesterPhone: phoneNumber,
        supplierNumber: requesterType === 'Supplier' ? branchCustRef : '',
      });

      const { data } = await saveTrailerRequest(requestData);
      if (data === 1) {
        setAlertMessage('Trailer Request Data Updated');
        setAlertOpen(false);
        setNewSuccessAlert(false);
        formUpdateTrailerRequest.resetFields();
        dispatch(setTrailerRequestId(trailerReqID));
        if (trailerRequestStatusID === 'SBMT' || trailerRequestStatusID === 'RECV') {
          navigate('/trailer-request-management', {
            state: {
              requestID: trailerReqID,
              data: requestData,
              userType: userRole,
              companyId: companyId,
              requestUserType: requestUserType,
            },
          });
        } else {
          getTrailerRequestData(requestID);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const onAlertConfirm = () => {
    setAlertOpen(false);
  };
  const getTrailerList = async () => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getTrailersListEffect({ PageSize: DEFAULT_PAGE_SIZE, PageNumber: DEFAULT_PAGE_NUMBER });

      const filteredTrailers = data.filter((trailer) => trailer.status !== '');
      const options = filteredTrailers.map((row) => ({
        label: row.trailerNumber,
        value: row.trailerID,
      }));
      setTrailerOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerOptions([]);
    }
  };

  const getTrailerDetailsData = async (trailerID) => {
    try {
      const { data } = await getTrailerDetailsEffect(trailerID);
      if (data.length > 0) {
        setTrailerConditionStatusID(data[0].trailerStatusID);
        formUpdateTrailerRequest.setFieldsValue({
          ConditionStatus: data[0].trailerStatusID,
        });
        if (data[0].unitSizeID) {
          formUpdateTrailerRequest.setFieldsValue({
            trailerSize: data[0].unitSizeID,
          });
          setPickupTrailerSize(data[0].unitSizeID);
        }
      }
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusID('');
    }
  };

  const getTrailerSizes = async () => {
    try {
      const { data } = await getUnitSizesEffect();

      const options = data.map((row) => ({
        label: row.size,
        value: row.id,
      }));
      setTrailerSizeOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerSizeOptions([]);
    }
  };

  const getUserRelations = async () => {
    try {
      const { data } = await getUserRelationEffect();
      if (data.length > 0) {
        if (data[0].userType !== 'CT' && data[0].userType !== 'Store' && data[0].userType !== 'STORE') {
          setNameLabel('Supplier Name');
          setLocationLabel('Supplier Location ID');
          setAddressLabel('Supplier Address');
          setPhoneLabel('Supplier Phone #');
          setTrlHidden(true);
        }
      } else {
        setFullName('');
        setBranchKey(0);
        setLocationID(0);

        setBranchAddr1('');
        setBranchBusPhone('');
        setRSCM('');
        setSCS('');
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
    } catch (error) {
      console.error(error);

      setFullName('');
      setBranchKey(0);
      setLocationID(0);

      setBranchAddr1('');
      setBranchBusPhone('');
      setRSCM('');
      setSCS('');
    }
  };

  const getTrailerCommodities = async () => {
    try {
      const { data } = await getAllFreightCommodityIdEffect();

      const options = data.map((row) => ({
        label: row.freightCommodity,
        value: row.freightCommodityID,
      }));
      setCommodityOptions(options);
    } catch (error) {
      console.error(error);
      setCommodityOptions([]);
    }
  };

  const getTrailerRequestStatus = async () => {
    try {
      const { data } = await getTrailerRequestStatusEffect();

      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setTrailerRequestStatusOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerRequestStatusOptions([]);
    }
  };

  const selectLocationID = (e) => {
    setLocationID(e.value);
    setBranchKey(e.value);
  };

  const selectTrailerRequestStatus = (e) => {
    setTrailerRequestStatusID(e.value);
  };
  const selectTrafficCoordinatorId = (e) => {
    setTrafficCoordinatorID(e.value);
  };
  const selectTrailerName = (e) => {
    setTrailerID(e.value);
    setTrailerName(e.label);
    getTrailerDetailsData(e.value);
  };
  const selectTrailerSize = (e) => {
    setPickupTrailerSize(e.value);
  };
  const selectRequestDate = (e) => {
    let trailerreqdate = moment(e).format().substring(0, 10);
    if (pTimeToCheck) {
      const newDate = `${trailerreqdate} ${pTimeToCheck}`;
      const date = new Date(newDate);
      trailerreqdate = getFormattedTimeString(date);
    }
    ValidatePickupDate(trailerreqdate);
    setTrailerRequestDate(trailerreqdate);
  };
  const selectRequestTime = (e) => {
    const trailerreqtime = moment(e).format('HH:mm:ss');
    setPTimeToCheck(moment(e).format('HH:mm'));
    const newDate = `${trailerRequestDate.substring(0, 10)} ${trailerreqtime}`;
    const date = new Date(newDate);
    const formattedDate = getFormattedTimeString(date);
    setTrailerRequestDate(formattedDate);
  };
  const setRequesterName = (e) => {
    setRequester(e.currentTarget.value);
  };
  const setSupplierPhone = (e) => {
    setPhoneNumber(e.currentTarget.value);
  };
  const selectCommodity = (e) => {
    setProductType(e.value);
    setEstimatedDimension(calculateLinearFeet(estimatedWeight, e.value));
  };
  const selectSealNumber = (e) => {
    setSealNumber(e.currentTarget.value);
  };
  const selectdeliveryCommodity = (e) => {
    setdeliveryProductType(e.value);
    setdeliveryProductTypeDesc(e.label);
  };
  const selectDeliveryDate = (e) => {
    const trailerdeldate = moment(e).format().substring(0, 10);
    ValidateDeliverydate(trailerdeldate);
    setDeliveryDate(trailerdeldate);
  };
  const selectDeliveryTime = (e) => {
    setDeliveryTime(e.value);
  };

  const selectDelivered = (e) => {
    let reqType = '';
    if (e.currentTarget.id === 'Empty') {
      setIsEmptyDelivered(true);
      setIsLoadedDelivered(false);
      setSelectedValue('Empty');
      reqType = 'Empty';
    } else if (e.currentTarget.id === 'Loaded') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(true);
      setSelectedValue('Loaded');
      reqType = 'Loaded';
    } else if (e.currentTarget.id === 'None') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(false);
      setSelectedValue('None');
      reqType = 'None';
    }
    if (selectedTrailerPickValue === '' && reqType !== '') {
      setRequestType('Outbound');
    } else if (selectedTrailerPickValue !== '' && reqType !== '') {
      setRequestType('Return');
    }
  };

  const setProdWeight = (e) => {
    if (e.target.value) {
      const value = e.currentTarget.value;
      setEstimatedWeight(value);
      setEstimatedDimension(calculateLinearFeet(value, productType));
    } else {
      setEstimatedWeight(null);
    }
  };
  const setProdDimension = (e) => {
    setEstimatedDimension(e.currentTarget.value);
  };
  const selectProduct = (e) => {
    setProductName(e.currentTarget.value);
  };

  const CloseModal = () => {
    setHidden(!hidden);
  };
  const setLiveLoadUnloadHour = (e) => {
    if (e) setLiveLoadHours(e.value);
    else {
      setLiveLoadHours(0);
    }
  };
  const handleChangeLoaded = (e) => {
    dispatch(setAppLoader(true));
    let reqType = '';
    setChecked(!checked);

    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      reqType = 'Empty';
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'EMT');
      } else {
        getTrailerList('', 'EMT');
      }
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      reqType = 'Loaded';
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'LOD');
      } else {
        getTrailerList('', 'LOD');
      }
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      reqType = 'None';
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }

    if (reqType !== '' && reqType !== 'None' && (selectedValue === '' || selectedValue === 'None')) {
      setRequestType('Inbound');
    } else if (reqType !== '' && reqType !== 'None' && selectedValue !== '' && selectedValue !== 'None') {
      setRequestType('Round');
    } else if (reqType === 'None' && selectedValue === 'None') {
      setRequestType('');
      setAlertOpen(true);
      setAlertMessage('Please provide instruction.');
    } else if (reqType === 'None' && selectedValue === '') {
      setRequestType('');
    } else if (selectedValue !== 'None' && selectedValue !== '' && reqType === 'None') {
      setRequestType('Outbound');
    }
    dispatch(setAppLoader(false));
  };
  const handleChangeEmpty = (e) => {
    dispatch(setAppLoader(true));
    let reqType = '';
    setChecked(false);

    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      reqType = 'Empty';
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'EMT');
      } else {
        getTrailerList('', 'EMT');
      }
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      reqType = 'Loaded';
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'LOD');
      } else {
        getTrailerList('', 'LOD');
      }
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      reqType = 'None';
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }

    if (reqType !== '' && reqType !== 'None' && (selectedValue === '' || selectedValue === 'None')) {
      setRequestType('Inbound');
    } else if (reqType !== '' && reqType !== 'None' && selectedValue !== '' && selectedValue !== 'None') {
      setRequestType('Round');
    } else if (reqType === 'None' && selectedValue === 'None') {
      setRequestType('');
      setAlertOpen(true);
      setAlertMessage('Please provide instruction.');
    } else if (reqType === 'None' && selectedValue === '') {
      setRequestType('');
    } else if (selectedValue !== 'None' && selectedValue !== '' && reqType === 'None') {
      setRequestType('Outbound');
    }
    dispatch(setAppLoader(false));
  };
  const selectDoorType = (e) => {
    setTrailerDoorType(e.currentTarget.value);
    if (e.currentTarget.id === 'Swingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'RollUpdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Slidingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Foldingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Hingeddoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    }
  };

  const selectLiveLoad = (e) => {
    if (e.currentTarget.value === 'Yes') {
      setIsLiveLoad(true);
      setSelectedLoadValue('Load');
    } else if (e.currentTarget.value === 'No') {
      setIsLiveLoad(false);
      setSelectedLoadValue('UnLoad');
      formUpdateTrailerRequest.setFieldValue('LiveLoadHours', '');
    }
  };
  const selectSpecialInstruction = (e) => {
    setSpecialInstruction(e.currentTarget.value);
  };

  const ValidateLoaded = () => {
    if (
      (selectedTrailerPickValue !== '' &&
        selectedTrailerPickValue !== 'None' &&
        selectedTrailerPickValue !== undefined) ||
      (selectedValue !== '' && selectedValue !== 'None' && selectedValue !== undefined)
    ) {
      return true;
    }

    if (!selectedTrailerPickValue && !selectedValue) {
      setAlertOpen(true);
      setAlertMessage('Please choose Pickup-Delivery option');
      return false;
    }

    if (specialInstruction !== '' && specialInstruction !== undefined) {
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Please provide instruction.');
    return false;
  };

  const ValidateTrailer = () => {
    if (userRole !== 'Store') {
      return true;
    }

    if (selectedTrailerPickValue === 'Empty' || selectedTrailerPickValue === 'Loaded') {
      if (trailerID === 0) {
        setAlertOpen(true);
        setAlertMessage('Select Trailer');
        return false;
      }
      return true;
    }

    return true;
  };

  const ValidateCommodity = () => {
    if (selectedTrailerPickValue !== 'Loaded') {
      if (document.getElementById('errorCommodity') !== null) {
      }
      return true;
    }

    if (productType !== '' && productType !== undefined) {
      if (document.getElementById('errorCommodity') !== null) {
      }
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select commodity');
    return false;
  };

  const ValidateDeliverydate = (deliveryDate) => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      const minDate = moment().add(3, 'days').startOf('day');
      const selectedDate = moment(deliveryDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested date is not within 72 hours.  The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const ValidatePickupDate = (pickupDate) => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      const minDate = moment().add(3, 'days').startOf('day');
      const selectedDate = moment(pickupDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested pickup date is not within 72 hours. The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const ValidateDeliveryTimeRange = () => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      if (deliveryTime) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage('Please select delivery time between 8 AM and 4 PM');
      return false;
    }
    return true;
  };

  const ValidatePickUpdate = () => {
    if (trailerRequestDate) {
      return true;
    }
    setAlertOpen(true);
    setAlertMessage('Pickup date required');
    return false;
  };

  const ValidateTrafficCoordinator = () => {
    if (trafficCoordinatorID !== 0) {
      return true;
    }
    setAlertOpen(true);
    setAlertMessage('Select Traffic Coordinator');
    return false;
  };

  const ValidateStop = () => {
    if (isMultiStop === false) {
      return true;
    }

    if (stop1 !== 0 && stop1 !== '0') {
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select stop1 location');
    return false;
  };

  const ValidateDelCommodity = () => {
    if (selectedValue !== 'Loaded') {
      return true;
    }

    if (deliveryproductType !== '' && deliveryproductType !== undefined) {
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select delivery commodity');
    return false;
  };

  const trailerSize = formUpdateTrailerRequest.getFieldValue('trailerSize') || 0;

  const trailerValue = getTrailerLabel(trailerSize, trailerSizeOptions);

  const percentage =
    trailerValue > 0 && estimatedDimension >= 0 ? Math.min((estimatedDimension / trailerValue) * 100, 100) : 0;
  const getProgressBarColor = (percentage) => {
    if (percentage <= 90) return 'red';
    if (percentage <= 95) return 'yellow';
    return 'green';
  };

  const progressBarColor = getProgressBarColor(percentage);

  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1">
            {' '}
            <strong> {userRole} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>

      <div className="h-100 pb-15">
        <Row className="flex-direction-column flex-nowrap  h-100 ">
          <Col className="flex-1 custom-scroll-bar">
            <Form form={formUpdateTrailerRequest}>
              <div className="pb-5">
                <Paper className="mb-10">
                  <div className="p-10">
                    <Row gutter={15}>
                      <Col sm={4} className="px-10" style={{ borderRight: '5px solid #00557d26' }}>
                        <div className="fw-bold text-center mb-2">
                          <u>
                            <label htmlFor="">Requester Details</label>
                          </u>
                        </div>

                        <Row gutter={15}>
                          <Col sm={24}>
                            <FormInput
                              inputType="text"
                              name="txtfullName"
                              label={nameLabel}
                              margin="m-0"
                              editMode
                              defaultValue={fullName}
                              placeholder="Auto populated value"
                              readOnly
                            />
                          </Col>

                          <Col sm={24}>
                            {requesterType !== 'Supplier' && (
                              <FormInput
                                name="txtSCS"
                                label="SCS"
                                margin="m-0"
                                editMode
                                defaultValue={scs}
                                placeholder="Auto populated value"
                                readOnly
                              />
                            )}
                            {requesterType === 'Supplier' && (
                              <FormInput
                                name="txtRequester"
                                label="Requester Name"
                                margin="m-0"
                                editMode
                                value={requester}
                                placeholder="Requester Name"
                                defaultValue={requester}
                                onChange={setRequesterName}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {requesterType !== 'Supplier' && (
                              <FormInput
                                name="txtRSCM"
                                label="RSCM"
                                margin="m-0"
                                editMode
                                defaultValue={rscm}
                                placeholder="Auto populated value"
                                readOnly
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            <FormSelectBox
                              label={locationLabel}
                              editMode
                              id="selPartnerLocation"
                              name="PartnerLocation"
                              margin="m-0"
                              options={partnerLocationOptions}
                              placeholder="Select Partner Location"
                              onChange={selectLocationID}
                              defaultValue={trailerRequestLocation}
                              value={locationID}
                              disabled
                            />
                          </Col>

                          <Col sm={24}>
                            <FormInput
                              name="txtAddr1"
                              label={addressLabel}
                              margin="m-0"
                              editMode
                              defaultValue={branchAddr1}
                              placeholder="Auto populated value"
                              readOnly
                            />
                          </Col>
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtAddr2"
                                label="Supplier Address2"
                                margin="m-0"
                                editMode
                                value={branchAddr2}
                                placeholder="Supplier Address2"
                                defaultValue={branchAddr2}
                                readOnly
                              />
                            </Col>
                          )}

                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtState"
                                label="Supplier State"
                                margin="m-0"
                                editMode
                                value={branchState}
                                placeholder="Supplier State"
                                defaultValue={branchState}
                                readOnly
                              />
                            </Col>
                          )}
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtCity"
                                label="Supplier City"
                                margin="m-0"
                                editMode
                                value={branchCity}
                                placeholder="Supplier City"
                                defaultValue={branchCity}
                                readOnly
                              />
                            </Col>
                          )}
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtPostal"
                                label="Supplier Zip"
                                margin="m-0"
                                editMode
                                value={branchPostal}
                                placeholder="Supplier Zip"
                                defaultValue={branchPostal}
                                readOnly
                              />
                            </Col>
                          )}
                          <Col sm={24}>
                            <FormInput
                              name="txtPhone"
                              label={phoneLabel}
                              margin="m-0"
                              editMode
                              defaultValue={requesterType === 'Supplier' ? phoneNumber : branchBusPhone}
                              placeholder="Phone Number"
                              readOnly={requesterType !== 'Supplier'}
                              onChange={setSupplierPhone}
                            />
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={20} className="px-10">
                        <Card title="Pickup" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15}>
                            <Col sm={16}>
                              <Row gutter={15} className="mb-5">
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12 text-black">
                                    We need a trailer picked up:
                                  </SecondaryLabel>
                                </Col>

                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickLoaded"
                                        checked={selectedTrailerPickValue === 'Loaded'}
                                        id="pickLoaded"
                                        value="Loaded"
                                        onClick={handleChangeLoaded}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Loaded </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickEmpty"
                                        checked={selectedTrailerPickValue === 'Empty'}
                                        id="pickEmpty"
                                        value="Empty"
                                        onClick={handleChangeEmpty}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickNone"
                                        checked={selectedTrailerPickValue === 'None'}
                                        id="pickNone"
                                        value="None"
                                        onClick={handleChangeEmpty}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={15}>
                                <Col sm={4} hidden={trlHidden}>
                                  <FormSelectBox
                                    label="Trailer Number"
                                    editMode
                                    id="selTrailerName"
                                    name="selTrailerName"
                                    margin="m-0"
                                    options={trailerOptions}
                                    placeholder="Select Trailer"
                                    onChange={selectTrailerName}
                                    disabled={disableFlag}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    editMode
                                    label="Trailer Size"
                                    name="trailerSize"
                                    margin="m-0"
                                    options={trailerSizeOptions}
                                    placeholder="Select Trailer Size"
                                    onChange={selectTrailerSize}
                                    defaultValue={pickupTrailerSize}
                                    disabled
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormDatePicker
                                    name="trailerDate"
                                    label={pickupDateLabel}
                                    margin="m-0"
                                    onChange={selectRequestDate}
                                    defaultData={trailerRequestDate && moment(trailerRequestDate)}
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormTimePicker
                                    label={pickupTimeLabel}
                                    editMode
                                    name="selectPickupTime"
                                    margin="m-0"
                                    onChange={selectRequestTime}
                                    minuteStep={30}
                                    defaultData={trailerRequestDate && moment(trailerRequestDate).format('h:mm A')}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Pickup Location"
                                    editMode
                                    id="pickupLocation"
                                    name="pickupLocation"
                                    margin="m-0"
                                    disabled
                                    options={partnerLocationOptions}
                                    placeholder="Pickup Location"
                                    defaultValue={stopDesc2}
                                  />
                                </Col>
                              </Row>
                            </Col>

                            <Col sm={4}>
                              <FormSelectBox
                                label="Traffic Coordinator"
                                editMode
                                name="TrafficCoord"
                                margin="m-0"
                                options={trafficCoordinatorOptions}
                                placeholder="Select Traffic Coordinator"
                                onChange={selectTrafficCoordinatorId}
                                defaultValue={trafficCoordinatorID}
                              />
                            </Col>

                            <Col sm={4}>
                              <FormSelectBox
                                label="Request Status"
                                editMode
                                name="selRequestStatus"
                                margin="m-0"
                                options={trailerRequestStatusOptions}
                                placeholder="Select Trailer Request Status"
                                onChange={selectTrailerRequestStatus}
                                defaultValue={trailerRequestStatusDesc}
                              />
                            </Col>
                          </Row>

                          {(isLoadedPickUp || isEmptyPickUp) && (
                            <Row gutter={15} className="mt-10">
                              <Col sm={18}>
                                <Row gutter={15}>
                                  <Col sm={4}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="selCommodity"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectCommodity}
                                      defaultValue={productTypeDesc}
                                    />
                                  </Col>
                                  {isLoadedPickUp && (
                                    <>
                                      <Col sm={4}>
                                        <FormInput
                                          inputType="number"
                                          name="sealNumber"
                                          label="Seal Number"
                                          margin="m-0"
                                          editMode
                                          onChange={selectSealNumber}
                                          placeholder="Seal Number"
                                          disabled
                                        />
                                      </Col>

                                      {requesterType !== 'Supplier' && (
                                        <Col sm={14}>
                                          <div className="main-table-text" style={{ height: '60px' }}>
                                            <div className="react-bootstrap-table">
                                              <table className="w-100 table">
                                                <thead>
                                                  <tr className="table-top">
                                                    <th className="center-align">
                                                      <SecondaryLabel className="f-12 text-white">
                                                        {' '}
                                                        Product Type{' '}
                                                      </SecondaryLabel>
                                                    </th>
                                                    <th className="center-align ">
                                                      <SecondaryLabel className="f-12 text-white">
                                                        {' '}
                                                        Estimated Weight{' '}
                                                      </SecondaryLabel>
                                                    </th>
                                                    <th className="center-align">
                                                      <SecondaryLabel className="f-12 text-white">
                                                        {' '}
                                                        Estimated Linear Feet{' '}
                                                      </SecondaryLabel>
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td className="center-align">
                                                      <input
                                                        className="form-control-sm"
                                                        type="text"
                                                        id="txtProdType"
                                                        onChange={selectProduct}
                                                        value={productName}
                                                      />
                                                    </td>
                                                    <td className="center-align">
                                                      <input
                                                        className="form-control-sm"
                                                        type="number"
                                                        id="txtProdWeight"
                                                        onChange={setProdWeight}
                                                        value={estimatedWeight}
                                                      />
                                                    </td>
                                                    <td className="center-align">
                                                      <input
                                                        className="form-control-sm"
                                                        disabled
                                                        id="txtProdDimension"
                                                        onChange={setProdDimension}
                                                        value={estimatedDimension}
                                                      />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </Col>
                                      )}
                                    </>
                                  )}
                                </Row>
                              </Col>

                              {isLoadedPickUp && requesterType !== 'Supplier' && (
                                <Col sm={6}>
                                  <div className="progress-container">
                                    <div className="text-center" style={{ color: progressBarColor }}>
                                      {percentage.toFixed(1)}% utilized
                                    </div>
                                    <CustomProgress
                                      percent={percentage}
                                      size={[280, 25]}
                                      strokeLinecap="butt"
                                      strokeColor={progressBarColor}
                                      showInfo={false}
                                    />
                                  </div>
                                </Col>
                              )}
                            </Row>
                          )}
                        </Card>
                        <Card title="Delivery" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15} className="mt-10">
                            <Col sm={16}>
                              <Row gutter={15}>
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12 text-black">
                                    {' '}
                                    We need a trailer delivered:{' '}
                                  </SecondaryLabel>
                                </Col>
                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryLoaded"
                                        checked={selectedValue === 'Loaded'}
                                        id="Loaded"
                                        value="Loaded"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Loaded </SecondaryLabel>
                                    </Col>
                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryEmpty"
                                        checked={selectedValue === 'Empty'}
                                        id="Empty"
                                        value="Empty"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryNone"
                                        checked={selectedValue === 'None'}
                                        id="None"
                                        value="None"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row gutter={15} className="mt-5">
                                <Col sm={6}>
                                  <FormDatePicker
                                    label="Delivery Date "
                                    name="deliveryDate"
                                    margin="m-0"
                                    value={deliveryDate}
                                    onChange={selectDeliveryDate}
                                    defaultData={moment(deliveryDate)}
                                    allowClear={false}
                                    disabledTargetDate={new Date()}
                                    disableFuture={false}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <SecondaryLabel className="f-12 text-black"> Delivery Time </SecondaryLabel>
                                  <FormSelectBox
                                    editMode
                                    className="mt-2 w-100"
                                    name="selectDeliveryTime"
                                    margin="m-0"
                                    value={deliveryTime}
                                    onChange={selectDeliveryTime}
                                    placeholder="Delivery Location"
                                    options={deliveryTimeOptions}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <FormSelectBox
                                    label="Delivery Location"
                                    editMode
                                    id="deliveryLocation"
                                    name="deliveryLocation"
                                    value={locationID}
                                    disabled
                                    margin="m-0"
                                    options={partnerLocationOptions}
                                    placeholder="Delivery Location"
                                    defaultValue={stopDesc2}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          {isLoadedDelivered && (
                            <Row gutter={15} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={15} className="mb-2">
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="selCommodity1"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectdeliveryCommodity}
                                      defaultValue={deliveryproductTypeDesc}
                                    />
                                  </Col>
                                </Row>
                              </Col>

                              <Col sm={6}>
                                <div className="p-10 mt-2 background-danger-1" hidden>
                                  <SecondaryLabel className="f-12 text-white">
                                    {' '}
                                    Trailer # 25468 is 90% consumed{' '}
                                  </SecondaryLabel>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Paper>

                <div className="floating-table-overlay" hidden={hidden} />
                <div hidden={hidden} className="floating-table shadow-sm full-height-modal" style={{ width: '55%' }}>
                  <div className="popup-header d-flex justify-content-between p-2 text-white theme-color">
                    <div className="">
                      <span />
                    </div>
                    <div className="">
                      <Button onClick={CloseModal}>
                        <i className="fas fa-times close-modal" />
                      </Button>
                    </div>
                  </div>
                  <div className="popup-body p-5">
                    <p className="h6">
                      {' '}
                      Before you submit your trailer request, please review the details below to ensure accuracy.
                    </p>
                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Trailer #: </label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{trailerName}</span>
                      </div>
                    </div>

                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Date Trailer Loaded: </label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{trailerRequestDate}</span>
                      </div>
                    </div>

                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Time Trailer Loaded:</label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{moment(trailerRequestDate).format('h:mm a')}</span>
                      </div>
                    </div>

                    <div className="text-center mt-5">
                      <button type="button" className="btn btn-dipblue me-5" onClick={SaveTrailerRequest}>
                        {' '}
                        Proceed{' '}
                      </button>
                      <button type="button" className="btn btn-dipblue" onClick={CloseModal}>
                        {' '}
                        Cancel{' '}
                      </button>
                    </div>
                  </div>
                </div>

                <Paper>
                  <AlertModal
                    title="Alert"
                    open={alertOpen}
                    description={alertMessage}
                    onOk={onAlertConfirm}
                    onClose={onAlertConfirm}
                  />
                  <WarningModal
                    alertTitle="Warning"
                    open={warningModal}
                    description={warning}
                    onClose={() => setWarningModal(false)}
                    onOk={() => setWarningModal(false)}
                  />
                  <ConfirmationModal
                    title="Alert"
                    open={newSuccessAlert}
                    description={successMessage}
                    onOk={SaveTrailerRequest}
                    onClose={onConfirmFunc}
                    onCancel={onConfirmFunc}
                    cancelButton={false}
                    okButtonVariant="error"
                  />
                  <div className="card-header p-8">Special Instructions</div>

                  <div className="p-10">
                    <Row gutter={15}>
                      <Col sm={14}>
                        <Row gutter={20} className="mb-8">
                          <Col sm={4}>
                            <SecondaryLabel className="f-12"> Trailer Door Type: </SecondaryLabel>
                          </Col>

                          <Col sm={20}>
                            <Row gutter={15}>
                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'Swingdoor'}
                                  name="trlSwingdoor"
                                  id="Swingdoor"
                                  value="SWNGDR"
                                  onClick={selectDoorType}
                                />
                                <SecondaryLabel className="f-12"> Swing door </SecondaryLabel>
                              </Col>

                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'RollUpdoor'}
                                  name="trlRollUpdoor"
                                  id="RollUpdoor"
                                  value="RLLUPDR"
                                  onClick={selectDoorType}
                                />
                                <SecondaryLabel className="f-12"> Roll door </SecondaryLabel>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row gutter={20} className="mb-2">
                          <Col sm={8}>
                            <Row gutter={15}>
                              <Col sm={12}>
                                <SecondaryLabel className="f-12"> Live Load / Unload: </SecondaryLabel>
                              </Col>
                              <Col sm={12}>
                                <Row gutter={15}>
                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbLoad"
                                      checked={selectedLoadValue === 'Load'}
                                      id="Load"
                                      value="Yes"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> Yes </SecondaryLabel>
                                  </Col>

                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbUnload"
                                      checked={selectedLoadValue === 'UnLoad'}
                                      id="Unload"
                                      value="No"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> No </SecondaryLabel>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm={6}>
                            {isLiveLoad && (
                              <FormSelectBox
                                label={
                                  <Tooltip title="Driver stays on site while loading/unloading 1-4 hours max.">
                                    Live Load / Unload Hours:
                                  </Tooltip>
                                }
                                editMode
                                name="LiveLoadHours"
                                margin="m-0"
                                options={liveLoadHoursOptions}
                                placeholder="Live Load/Unload Hours"
                                onChange={setLiveLoadUnloadHour}
                                defaultValue={liveLoadHours}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={10}>
                        <FormTextArea
                          editMode
                          name="txtSpclInstruct"
                          margin="mb-14"
                          placeholder="Special Instructions"
                          enableAutoFocus={false}
                          rows={3}
                          value={specialInstruction}
                          defaultValue={specialInstruction}
                          onChange={selectSpecialInstruction}
                        />

                        <div className="text-center">
                          <button type="button" className="btn btn-dipblue mr-5" onClick={() => navigate('/savers')}>
                            Exit
                          </button>
                          <button type="button" className="btn btn-dipblue" onClick={onProceed} hidden={disableFlag}>
                            {trailerRequestStatusID === 'RECV' || trailerRequestStatusID === 'SBMT'
                              ? 'Proceed'
                              : 'Save Changes'}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Paper>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
}
